import script from "./SfxToggleSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./SfxToggleSettings.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QSpace,QToggle});
